import fetch from '@zillow/fetchier';

var REQUEST_TIMEOUT = 1000;
/**
 * Fetch data from the shared session state service (s3s)
 * @param {string} guid
 * @param {string} [s3sUrl] shared session state service endpoint, defaults to develop VIP
 * @param {Object} [optParms]
 * @param {string} [optParms.ipAddr] ip is only needed when requesting geoIpLocation data
 * @namespace s3sClient
 */

var s3sClient = function s3sClient(guid, s3sUrl, optParams, timeout) {
  if (s3sUrl === void 0) {
    s3sUrl = 'http://s3s.develop.zillow.net';
  }

  if (optParams === void 0) {
    optParams = {};
  }

  if (timeout === void 0) {
    timeout = REQUEST_TIMEOUT;
  }

  /**
   * @param {Array} data The data requsted from S3S.
   * @returns {Object} JSON data from the S3S endpoint. 'currentGeography', if present, will be an object that gives the 'best' and the 'latest' regionIDs. 'geoIpLocation", if valid will, will be an object with city, state, zipcode and latLong.
   */
  var fetchSharedSessionState = function fetchSharedSessionState(data) {
    return fetch(s3sUrl + "/V1/data/" + data.join(','), {
      query: Object.assign({
        guid: guid
      }, optParams),
      timeout: timeout
    }).then(function (response) {
      return response.json();
    }).then(function (payload) {
      if (typeof payload === 'undefined') {
        throw new Error('sharedSessionState returned no data');
      }

      return payload;
    }).catch(function (e) {
      throw e;
    });
  };
  /**
   * @param {Array} requestedItems data items requested from S3S. Current options: 'currentGeography', 'geoIpLocation'
   * @returns {Promise} Promise object with data requested from getChasedSessionState()
   */


  var getSharedSessionState = function getSharedSessionState(requestedItems) {
    if (requestedItems === void 0) {
      requestedItems = [];
    }

    return new Promise(function (resolve) {
      if (requestedItems.length === 0) {
        throw new Error('requestedItems parameter must contain at least one item');
      }

      if (requestedItems.includes('geoIpLocation') && typeof optParams.ipAddr === 'undefined') {
        throw new Error('ipAddr must be passed when requesting geoIpLocation');
      }

      resolve(fetchSharedSessionState(requestedItems));
    });
  };

  return {
    getSharedSessionState: getSharedSessionState
  };
};

export default s3sClient;
